import React from 'react';

const STAGES = [
  { key: 'capture', label: '촬영', icon: '📷' },
  { key: 'analyze', label: '분석', icon: '🤖' },
  { key: 'record', label: '기록', icon: '💾' },
  { key: 'output', label: '출력', icon: '📄' },
];

export default function PipelineProgress({ currentStage, progress }) {
  const currentIndex = STAGES.findIndex(s => s.key === currentStage);
  const totalStages = STAGES.length;
  const stageProgress = ((currentIndex + (progress > 0 ? progress / 100 : 0)) / totalStages) * 100;

  return (
    <div style={{
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '1rem 0.5rem',
      background: 'var(--color-surface-dim, #f8f9fa)',
      borderRadius: 'var(--radius-lg, 0.75rem)',
      marginBottom: 'var(--space-lg, 1.5rem)',
      overflow: 'hidden',
    }}>
      {/* Background connector line */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '2.5rem',
        right: '2.5rem',
        height: '3px',
        background: '#e9ecef',
        transform: 'translateY(-6px)',
        borderRadius: '2px',
      }}>
        {/* Filled connector line */}
        <div style={{
          height: '100%',
          background: 'linear-gradient(90deg, var(--color-success, #28a745), var(--color-accent, #667eea))',
          borderRadius: '2px',
          width: `${Math.min(100, Math.max(0, ((currentIndex) / (totalStages - 1)) * 100))}%`,
          transition: 'width 0.5s ease',
        }} />
      </div>

      {STAGES.map((stage, i) => {
        const isActive = i === currentIndex;
        const isDone = i < currentIndex;

        return (
          <div
            key={stage.key}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '0.3rem',
              position: 'relative',
              zIndex: 1,
              flex: 1,
            }}
          >
            <div style={{
              width: '2.5rem',
              height: '2.5rem',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: isDone
                ? 'var(--color-success, #28a745)'
                : isActive
                  ? 'var(--color-accent, #667eea)'
                  : '#f0f0f0',
              color: isDone || isActive ? 'white' : '#999',
              fontSize: isDone ? '1rem' : '1.2rem',
              fontWeight: 'bold',
              transition: 'all 0.4s ease',
              boxShadow: isActive ? '0 0 0 4px rgba(102, 126, 234, 0.25)' : 'none',
              animation: isActive ? 'pulse 2s ease-in-out infinite' : isDone ? 'scaleIn 0.3s ease' : 'none',
            }}>
              {isDone ? '✓' : stage.icon}
            </div>
            <span style={{
              fontSize: 'var(--font-size-xs, 0.7rem)',
              color: isActive
                ? 'var(--color-accent, #667eea)'
                : isDone
                  ? 'var(--color-success, #28a745)'
                  : 'var(--color-text-muted, #999)',
              fontWeight: isActive || isDone ? 700 : 400,
              transition: 'color 0.3s',
            }}>
              {stage.label}
            </span>
          </div>
        );
      })}

      {/* Overall progress bar at bottom */}
      {progress > 0 && progress < 100 && (
        <div style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '3px',
          background: '#e9ecef',
        }}>
          <div style={{
            width: `${stageProgress}%`,
            height: '100%',
            background: 'var(--gradient-accent)',
            borderRadius: '0 2px 2px 0',
            transition: 'width 0.5s ease',
          }} />
        </div>
      )}

      {/* Progress percentage */}
      {progress > 0 && progress < 100 && (
        <div style={{
          position: 'absolute',
          top: '4px',
          right: '8px',
          fontSize: '0.65rem',
          color: 'var(--color-accent, #667eea)',
          fontWeight: 700,
        }}>
          {Math.round(progress)}%
        </div>
      )}
    </div>
  );
}
